import React from 'react'
import './styles.scss'

export function KantonTitel(props) {
  
      return (
        <>
          <h2 className='dashboardTitel'>{props.titel}</h2>
        </>
      )
}